module.exports = __webpack_public_path__ + "static_portal/media/actor_1.9a09dc54.mp4";